import { Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import CardImovel from '../CardImovel/CardImovel'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'

const ImoveisEncontrados = () => {
    const { imoveis } = useContext(VisitantesContext)

    return (
        <Grid component={'form'} sx={{
            display: 'flex',
            width: '100%',
            height: '25%',
            borderBottom: '1px solid white',
            alignItems: 'flex-start',
            justifyContent: 'space-around'
        }}>
            {imoveis && imoveis.length > 0
                ? (
                    <Grid sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        width: '100%'
                    }}>
                        <Typography sx={{
                            color: 'red',
                            fontSize: '17px',
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            Certifique-se qual é o imóvel correto com o VISITANTE!
                        </Typography>
                        <Grid sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-around',
                            flexWrap: 'wrap',
                            overflowY: 'scroll',
                            height: '100%',
                            width: '100%'
                        }}>
                            {
                                imoveis.map((imovel, index) => {
                                    return <CardImovel imovel={imovel} key={index} />
                                })
                            }
                        </Grid>
                    </Grid>
                )
                : (
                    imoveis && imoveis.length === 0
                        ? (<Typography sx={TypographySx}>
                        Nenhum imóvel encontrado para essa pesquisa!
                        </Typography>)
                        : (
                            <Typography sx={TypographySx}>
                            Aguardando pesquisa...
                            </Typography>
                        )
                )
            }
        </Grid>
    )
}

export default ImoveisEncontrados

const TypographySx = {
    color: 'black',
    fontWeight: 700,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}
